"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSansRegular = require('./OpenSans-Regular.msdf.bin');
